import { render, staticRenderFns } from "./JSelectJxrw.vue?vue&type=template&id=19937232&scoped=true"
import script from "./JSelectJxrw.vue?vue&type=script&lang=js"
export * from "./JSelectJxrw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19937232",
  null
  
)

export default component.exports